import { Box, Typography, useTheme, useMediaQuery } from "@mui/material";
import { tokens } from "../theme";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";

const StatBox = ({ title, subtitle, priceData }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const { current, previous } = priceData;

  const isMobile = useMediaQuery("(max-width:600px)");

  const isPriceIncreased = current > previous;
  const priceChangeIcon = isPriceIncreased ? (
    <ArrowUpwardIcon
      sx={{
        color: colors.greenAccent[500],
        fontSize: isMobile ? "18px" : "26px",
      }}
    />
  ) : (
    <ArrowDownwardIcon
      sx={{
        color: colors.redAccent[500],
        fontSize: isMobile ? "18px" : "26px",
      }}
    />
  );

  return (
    <Box width="100%" height="80px">
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography
          fontWeight="bold"
          sx={{
            color: colors.grey[100],
            marginLeft: "10px",
            fontSize: isMobile ? "16px" : "24px",
          }}
        >
          {title}
        </Typography>
        <Box display="flex" alignItems="center" marginRight="10px">
          <Typography
            sx={{
              color: isPriceIncreased
                ? colors.greenAccent[500]
                : colors.redAccent[500],
              marginRight: "5px",
              fontSize: isMobile ? "14px" : "18px",
            }}
          >
            {subtitle}
          </Typography>
          {priceChangeIcon}
        </Box>
      </Box>
    </Box>
  );
};

export default StatBox;
